/* LumiereRoyal welcome popup.
 * Subscribes through Shopify's native customer form (contact[email] + marketing consent).
 * No API keys, no third-party endpoints. */
(function () {
  'use strict';

  var dialog = document.getElementById('LrPopup');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var DELAY_MS = 12000;
  var DISMISS_DAYS = 7;
  var KEY_DISMISSED = 'lr_popup_dismissed_until';
  var KEY_SUBSCRIBED = 'lr_popup_subscribed';
  var KEY_PENDING = 'lr_popup_pending';
  var SESSION_SEEN = 'lr_popup_seen';

  var form = dialog.querySelector('form');
  var email = dialog.querySelector('#LrPopupEmail');
  var submit = dialog.querySelector('.lr-popup__submit[type="submit"]');
  var status = dialog.querySelector('#LrPopupStatus');
  var formView = dialog.querySelector('[data-lr-view="form"]');
  var successView = dialog.querySelector('[data-lr-view="success"]');
  var successHeading = dialog.querySelector('[data-lr-success-heading]');
  var lastFocus = null;
  var busy = false;

  var MSG = {
    invalid: 'Please enter a valid email address, like name@example.com.',
    existing: 'You’re already on our list. Your welcome offer was sent when you first signed up, so check your inbox (and spam folder).',
    failed: 'Sorry, we couldn’t sign you up just now. Please check your connection and try again.'
  };

  function storeGet(k, session) {
    try { return (session ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; }
  }
  function storeSet(k, v, session) {
    try { (session ? sessionStorage : localStorage).setItem(k, v); } catch (e) {}
  }
  function storeDel(k) {
    try { localStorage.removeItem(k); } catch (e) {}
  }

  var params = new URLSearchParams(window.location.search);
  var forcePreview = params.get('lr_popup') === 'preview';
  var designMode = dialog.getAttribute('data-design-mode') === 'true';
  var eligiblePage = dialog.getAttribute('data-eligible') === 'true';

  function isSuppressed() {
    if (storeGet(KEY_SUBSCRIBED)) return true;
    var until = parseInt(storeGet(KEY_DISMISSED) || '0', 10);
    if (until && Date.now() < until) return true;
    if (storeGet(SESSION_SEEN, true)) return true;
    return false;
  }

  /* Another email app already showing / providing a signup popup? */
  function otherAppPopupPresent() {
    var selectors = [
      '.klaviyo-form', '[class*="kl-private-reset-css"]', 'div[aria-label="POPUP Form"]',
      '#privy-container', '.privy-popup-container',
      '.omnisend-form', '[id^="omnisend-form"]', '.soundest-form',
      'iframe[src*="forms.shopifyapps.com"]', 'shopify-forms-embed', '[data-shopify-forms]',
      '.mailchimp-popup', '#mc_embed_signup', '#justuno_form', '.wisepops-root', '.pop-convert'
    ];
    for (var i = 0; i < selectors.length; i++) {
      if (document.querySelector(selectors[i])) return true;
    }
    return !!(window.Privy || window.omnisend || window.Wisepops || window.juapp);
  }

  /* Don't interrupt: cart drawer, other dialogs, or checkout-type pages. */
  function interruptsSomething() {
    if (document.querySelector('dialog[open]:not(#LrPopup)')) return true;
    if (document.querySelector('cart-drawer-component[open], cart-drawer[open], .cart-drawer[open], [data-cart-drawer][open], details[open].cart-drawer')) return true;
    if (/\/(cart|checkouts?|account|challenge)(\/|$)/.test(window.location.pathname)) return true;
    return false;
  }

  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null && !el.closest('[hidden]'); }
    );
  }

  function open(view) {
    if (dialog.open) return;
    lastFocus = document.activeElement;
    showView(view || 'form');
    dialog.showModal();
    document.documentElement.classList.add('lr-popup-open');
    storeSet(SESSION_SEEN, '1', true);
    if (view === 'success') { successHeading.focus(); } else { email.focus(); }
  }

  function close(reason) {
    if (!dialog.open) return;
    dialog.close();
    document.documentElement.classList.remove('lr-popup-open');
    if (reason === 'dismiss' && !storeGet(KEY_SUBSCRIBED)) {
      storeSet(KEY_DISMISSED, String(Date.now() + DISMISS_DAYS * 864e5));
    }
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus();
    }
  }

  function showView(view) {
    var success = view === 'success';
    formView.hidden = success;
    successView.hidden = !success;
  }

  function setStatus(msg, kind) {
    status.textContent = msg || '';
    status.classList.toggle('is-error', kind === 'error');
    email.setAttribute('aria-invalid', kind === 'error' ? 'true' : 'false');
  }

  function setBusy(on) {
    busy = on;
    submit.disabled = on;
    submit.setAttribute('aria-busy', on ? 'true' : 'false');
    submit.textContent = on ? 'Signing you up…' : submit.getAttribute('data-label');
  }

  function onSuccess() {
    storeSet(KEY_SUBSCRIBED, String(Date.now()));
    storeDel(KEY_DISMISSED);
    storeDel(KEY_PENDING);
    setStatus('', null);
    showView('success');
    successHeading.focus();
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  /* Read the result Shopify rendered for this form in the response page. */
  function readResult(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.getElementById('LrPopupStatus');
    if (!node) return { result: null };
    return { result: node.getAttribute('data-lr-result'), error: node.getAttribute('data-lr-error') || '' };
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (busy) return;
    var value = email.value.trim();
    email.value = value;
    if (!validEmail(value)) {
      setStatus(MSG.invalid, 'error');
      email.focus();
      return;
    }
    setStatus('', null);
    setBusy(true);

    fetch(form.getAttribute('action'), {
      method: 'POST',
      body: new URLSearchParams(new FormData(form)),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        /* Spam protection (hCaptcha) is on: finish the signup with a normal
           form post so the shopper can complete the challenge. */
        if (res.url && /\/challenge(\?|$|\/)/.test(res.url)) {
          storeSet(KEY_PENDING, String(Date.now()));
          form.removeEventListener('submit', handleSubmit);
          HTMLFormElement.prototype.submit.call(form);
          return null;
        }
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text().then(function (html) {
          var r = readResult(html);
          if (r.result === 'success') { onSuccess(); return; }
          if (r.result === 'error') {
            if (/taken|exist|already/i.test(r.error)) { setStatus(MSG.existing, 'info'); storeSet(KEY_SUBSCRIBED, String(Date.now())); return; }
            if (/invalid|blank|format/i.test(r.error)) { setStatus(MSG.invalid, 'error'); email.focus(); return; }
            throw new Error('Shopify error: ' + r.error);
          }
          throw new Error('Signup not confirmed');
        });
      })
      .catch(function () {
        setStatus(MSG.failed, 'error');
      })
      .then(function () { setBusy(false); });
  }

  /* ---------- wiring ---------- */
  submit.setAttribute('data-label', submit.textContent.trim());
  form.setAttribute('novalidate', '');
  form.addEventListener('submit', handleSubmit);

  dialog.addEventListener('cancel', function (e) { e.preventDefault(); close('dismiss'); });
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) { close('dismiss'); return; }
    var btn = e.target.closest('[data-lr-close]');
    if (btn) close(btn.getAttribute('data-lr-close') || 'dismiss');
  });
  dialog.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  email.addEventListener('input', function () {
    if (email.getAttribute('aria-invalid') === 'true') setStatus('', null);
  });

  /* Returning from a signup that had to go through the spam challenge,
     or any signup that succeeded on this page load. */
  var serverResult = status.getAttribute('data-lr-result');
  if (serverResult === 'success' && /[?&]customer_posted=true/.test(window.location.search)) {
    var cameFromPopup = !!storeGet(KEY_PENDING);
    storeSet(KEY_SUBSCRIBED, String(Date.now()));
    storeDel(KEY_PENDING);
    if (cameFromPopup) { open('success'); return; }
    return; /* subscribed through another form: never show the popup */
  }
  if (storeGet(KEY_PENDING) && serverResult === 'error') {
    storeDel(KEY_PENDING);
    open('form');
    setStatus(MSG.invalid, 'error');
    return;
  }

  if (forcePreview) { open('form'); return; }
  if (designMode || !eligiblePage || isSuppressed()) return;

  function tryShow() {
    if (isSuppressed() || otherAppPopupPresent()) return;
    if (interruptsSomething()) { window.setTimeout(tryShow, 2000); return; }
    open('form');
  }
  window.setTimeout(tryShow, DELAY_MS);
})();
